<mat-dialog-content>
	<p>
		{{ message }}
	</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
	<button mat-mdc-raised-button class="btn btn-submit" (click)="onConfirmClick()" tabindex="1">{{ confirmButtonText }}</button>
	<span class="mx-1"></span>
	<button mat-mdc-raised-button class="btn btn-cancel" (click)="onCancelClick()" mat-dialog-close tabindex="-1">{{ cancelButtonText }}</button>
</mat-dialog-actions>